import { render, staticRenderFns } from "./customConfirmLayerPopup.vue?vue&type=template&id=2490b6f1&scoped=true&"
import script from "./customConfirmLayerPopup.vue?vue&type=script&lang=js&"
export * from "./customConfirmLayerPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2490b6f1",
  null
  
)

export default component.exports